var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.7a.6.6 0 0 1 .6.6v7.1a.6.6 0 0 1-.6.6h-1a.6.6 0 0 1-.6-.6v-7.1a.6.6 0 0 1 .6-.6h1zM1.6 15a.6.6 0 0 1 .6.6v3.8a.6.6 0 0 1-.6.6h-1a.6.6 0 0 1-.6-.6v-3.8a.6.6 0 0 1 .6-.6h1zM15 8.8a.6.6 0 0 1 .6.6v10a.6.6 0 0 1-.6.6h-1a.6.6 0 0 1-.6-.6v-10a.6.6 0 0 1 .6-.6h1zm-8.9 4.5a.6.6 0 0 1 .6.6v5.5a.6.6 0 0 1-.6.6h-1a.6.6 0 0 1-.6-.6v-5.5a.6.6 0 0 1 .6-.6h1zM16 .831l-.105 6.224a.91.91 0 0 1-.118.319.477.477 0 0 1-.705.035l-1.067-1.313-.32-.231C10.964 10.56 3.302 13.58.141 11.766c-.243-.139-.156-.522.124-.524 5.248-.027 9.875-3.912 11.182-6.824l-1.841-.41c-.402-.14-.45-.705-.078-.915l.2-.113 2.705-1.528 2.392-1.35C15.36-.2 16.011.205 16 .832zM18.4 6.2h1a.6.6 0 0 1 .6.6v12.6a.6.6 0 0 1-.6.6h-1a.6.6 0 0 1-.6-.6V6.8a.6.6 0 0 1 .6-.6z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.69f5c87b0df91e880e99f22e4f106d05.svg";
export { ForwardRef as ReactComponent };